module.exports = __webpack_public_path__ + "static/media/banner-hire-us.95e3d1e4.svg";